import React, { FC } from 'react'
import { OrderTime, OrderType } from 'types/checkout'
import { UserType } from 'types/user'
import { DeliveryOrderCard } from 'components/Card'
import { Spacer } from 'components/Utility'
import { getEarliestCheckoutOrder } from 'lib/order'
import { StoreShippingType } from 'types/storeShipping'
import { parseDateWithHyphen } from 'lib/helper'

type Props = {
  orders: OrderType[]
  orderTimes: OrderTime[]
  sortType: 'checkout_at' | 'scheduled_delivery_at'
  storeShippingList: StoreShippingType[]
  users: UserType[]
}

const DeliveryOrderCardList: FC<Props> = (props) => {
  const { orders, orderTimes, sortType, storeShippingList, users } = props
  return (
    <div>
      {storeShippingList
        .sort((a, b) => {
          if (sortType === 'checkout_at') {
            return getEarliestCheckoutOrder(orders, a.user_id) > getEarliestCheckoutOrder(orders, b.user_id) ? -1 : 1
          } else {
            const aDate = new Date(`${parseDateWithHyphen(a.scheduled_delivery_date)} ${a.scheduled_delivery_time}`)
            const bDate = new Date(`${parseDateWithHyphen(b.scheduled_delivery_date)} ${b.scheduled_delivery_time}`)
            return aDate.getTime() < bDate.getTime() ? -1 : 1
          }
        })
        .map((storeShipping) => {
          const order = orders.find((order) => order.checkout_id === storeShipping.store_checkout_ref.id)
          if (!order) return
          const orderTime = orderTimes.find((orderTime) => orderTime.user_id === storeShipping.user_id)
          if (!orderTime) return
          const user = users.find((user) => user.user_id === storeShipping.user_id)
          return (
            <React.Fragment key={storeShipping.shipping_number}>
              <DeliveryOrderCard order={order} orderTime={orderTime} storeShipping={storeShipping} user={user} />
              <Spacer size={12} />
            </React.Fragment>
          )
        })}
    </div>
  )
}

export default DeliveryOrderCardList
